import template from './carrier.edit.html';
import controller from './carrier.edit.controller';
import './carrier.edit.controller';

let carriereditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default carriereditComponent;


// WEBPACK FOOTER //
// ./client/app/components/carrier/edit/carrier.edit.component.js